import login_bg from "../../assets/images/login_bg.png";
import bg_opacity from "../../assets/images/bg_opacity.png";
import logo from "../../assets/images/logo.png";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Form, Formik, ErrorMessage, Field } from "formik";
import * as Yup from "yup";
import { logInAdmin } from "../../Redux/Slices/authSlice";
import toast from "react-hot-toast";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPass, setShowPass] = useState(false);

  //initialValues
  const initialValues = {
    email: "",
    password: "",
  };

  const handleValidation = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email is Required"),
    password: Yup.string().required("Password is Required"),
  });

  const handleSubmit = async (values) => {
    const payload = { ...values };
    try {
      const response = await dispatch(logInAdmin(payload)).unwrap();

      if (response?.IsSuccess) {
        toast.success(response.Message);
        navigate("../users-analytics");
        // navigate("../dashboard");
      }
    } catch (error) {
      toast.error("Login Failed...!");
      console.log("error", error);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
        // Only redirect if token exists
        navigate("/users-analytics");
    }
  }, [navigate]);
  
  return (
    <>
      <section className="h-screen relative w-full overflow-hidden flex items-center justify-center">
        <img
          src={login_bg}
          alt="login_bg"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <img
          src={bg_opacity}
          alt="login_bg"
          className="absolute inset-0 w-full h-full object-cover"
        />

        <div className="relative z-10 w-[550px] bg-white rounded-[50px] shadow-lg px-8 lg:px-12 2xl:px-16 py-5 md:py-8 xl:py-11 m-4 md:m-0">
          <div className="flex items-center space-x-10 xl:space-x-12 mb-5 md:mb-7 xl:mb-9">
            <div className="w-16 xl:w-20 h-16 xl:h-20">
              <img src={logo} alt="Logo" className="rounded-full" />
            </div>
            <h2 className="text-32 xl:text-40 font-extrabold text-primary tracking-wider xl:tracking-widest">
              Login
            </h2>
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={handleValidation}
            onSubmit={handleSubmit}
          >
            <Form>
              <div className="mb-5 md:mb-7 2xl:mb-9">
                <label
                  htmlFor="username"
                  className="block text-12 sm:text-14 font-medium text-text_1 mb-1"
                >
                  Email
                </label>
                <Field
                  type="text"
                  id="username"
                  name="email"
                  placeholder="Enter Email"
                  className="w-full px-6 py-3.5 rounded-lg text-gray_2 text-14 sm:text-16 font-medium bg-input_color focus:outline-none"
                />
                <ErrorMessage
                  name="email"
                  component="span"
                  className="text-red text-12 sm:text-14 font-medium"
                />
                 <span
                    className="icon-eye  text-20 lg:text-24 text-gray-400 inline-block cursor-pointer absolute right-6 top-[35px] xl:top-[44px]"
                    onClick={() => setShowPass(!showPass)}
                  ></span>
              </div>
              <div className="mb-5 md:mb-7 2xl:mb-9">
                <label
                  htmlFor="password"
                  className="block text-12 sm:text-14 font-medium text-text_1 mb-1"
                >
                  Password
                </label>
                <Field
                   type={showPass ? "text" : "password"}
                  id="password"
                  name="password"
                  placeholder="Enter Password"
                  className="w-full px-6 py-3.5 rounded-lg text-black text-14 sm:text-16 font-medium bg-input_color focus:outline-none"
                />
                <span
                    className="text-20 lg:text-24 text-gray-400 inline-block cursor-pointer absolute right-14 lg:right-20 top-[248px] md:top-[282px] lg:top-2/3 xl:top-80 2xl:top-[327px] -translate-y-1/2"
                    onClick={() => setShowPass(!showPass)}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" x="0" y="0" viewBox="0 0 511.999 511.999" style={{ marginRight: 0 + 'em' }} xmlSpace="preserve"><g><path d="M508.745 246.041c-4.574-6.257-113.557-153.206-252.748-153.206S7.818 239.784 3.249 246.035a16.896 16.896 0 0 0 0 19.923c4.569 6.257 113.557 153.206 252.748 153.206s248.174-146.95 252.748-153.201a16.875 16.875 0 0 0 0-19.922zM255.997 385.406c-102.529 0-191.33-97.533-217.617-129.418 26.253-31.913 114.868-129.395 217.617-129.395 102.524 0 191.319 97.516 217.617 129.418-26.253 31.912-114.868 129.395-217.617 129.395z" fill="#9ca3af" opacity="1" data-original="#000000"></path><path d="M255.997 154.725c-55.842 0-101.275 45.433-101.275 101.275s45.433 101.275 101.275 101.275S357.272 311.842 357.272 256s-45.433-101.275-101.275-101.275zm0 168.791c-37.23 0-67.516-30.287-67.516-67.516s30.287-67.516 67.516-67.516 67.516 30.287 67.516 67.516-30.286 67.516-67.516 67.516z" fill="#9ca3af" opacity="1" data-original="#000000"></path></g></svg>
                </span>
                <ErrorMessage
                  name="password"
                  component="span"
                  className="text-red text-12 sm:text-14 font-medium"
                />
              </div>
              <div className="text-center">
                <button
                  type="submit"
                  className="text-base sm:text-lg font-bold whitespace-nowrap text-white hover:border-primary hover:text-primary bg-primary hover:bg-white border outline-none cursor-pointer rounded-lg px-10 sm:px-12 py-2.5 sm:py-3.5 anim"
                >
                  Login
                </button>
              </div>
            </Form>
          </Formik>
        </div>
      </section>
    </>
  );
};

export default Login;
